import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

let router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'RestaurantMap',
      path:'/restaurants/:restaurantId/map',
      props: true,
      component: () => import('@/views/constructor/Index'),
      meta: {
        title : 'Карта ресторана',
        requiresAuth : true
      },
    },
    {
      name: 'CurrentStatus',
      path:'/restaurants/:restaurantId/current-status',
      props: true,
      component: () => import('@/views/pages/Reservations/CurrentState2/Index'),
      meta: {
        title : 'Карта ресторана',
        requiresAuth : true
      },
    },
    {
      name: 'CurrentStatus2',
      path:'/restaurants/:restaurantId/current-status2',
      props: true,
      component: () => import('@/views/pages/Reservations/CurrentState2/Index'),
      meta: {
        title : 'Карта ресторана',
        requiresAuth : true
      },
    },
    {
      name: 'Login',
      path: '/login',
      component: () => import('@/views/pages/Login'),
    },
    {
      name: 'Register',
      path: '/register',
      component: () => import('@/views/pages/Register'),
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      meta: {
        requiresAuth : true
      },
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Pages
        {
          name: 'Мои аккаунт',
          path: 'pages/user',
          component: () => import('@/views/dashboard/pages/UserProfile'),
          meta: {
            title : 'Мои аккаунт',
            requiresAuth : true
          },
        },
        {
          name: 'restaurants',
          path: '/restaurants',
          component: () => import('@/views/pages/Restaurant/ListRestaurant'),
          meta: {
            title : 'Рестораны',
            requiresAuth : true
          },
        },
        {
          name: 'restaurantCreate',
          path: '/restaurants/create',
          component: () => import('@/views/pages/Restaurant/Create'),
          meta: {
            title : 'Создать ресторан',
            requiresAuth : true
          },
        },
        {
          name: 'restaurantEdit',
          path: '/restaurants/:id/edit',
          props: true,
          component: () => import('@/views/pages/Restaurant/Create'),
          meta: {
            title : 'Редактировать ресторан',
            requiresAuth : true
          },
        },
        {
          name: 'RestaurantZoneList',
          path: '/restaurants/:restaurantId/zones',
          props: true,
          component: () => import('@/views/pages/Restaurant/Zone/ListZone'),
          meta: {
            title : 'Зоны ресторана',
            requiresAuth : true
          },
        },
        {
          name: 'RestaurantZoneCreate',
          path: '/restaurants/:restaurantId/zones/create',
          props: true,
          component: () => import('@/views/pages/Restaurant/Zone/Create'),
          meta: {
            title : 'Создать зону ресторана',
            requiresAuth : true
          },
        },
        {
          name: 'RestaurantZoneEdit',
          path: '/restaurants/:restaurantId/zones/:id/edit',
          props: true,
          component: () => import('@/views/pages/Restaurant/Zone/Create'),
          meta: {
            title : 'Редактировать зону ресторана',
            requiresAuth : true
          },
        },
        {
          name: 'Лист Ожидания',
          path: 'components/icons',
          component: () => import('@/views/dashboard/component/Icons'),
        },
        {
          name: 'Резервы',
          meta: {
            title : 'Резервы',
            requiresAuth : true
          },
          path: 'reservations',
          component: () => import('@/views/pages/Reservations/Index'),
        },
        {
          name: 'listReservationForRestaurant',
          meta: {
            title : 'Резервы',
            requiresAuth : true
          },
          path: 'reservations/:restaurantId',
          props: true,
          component: () => import('@/views/pages/Reservations/Index'),
        },
        {
          name: 'viewReservation',
          path: 'reservations/:restaurantId/:id/view',
          props: true,
          component: () => import('@/views/pages/Reservations/View'),
        },
        {
          name: 'createReservation',
          props: true,
          meta: {
            title : 'Создать резерв',
            requiresAuth : true
          },
          path: 'reservations/:restaurantId/create',
          component: () => import('@/views/pages/Reservations/CreateReservation'),
        },
        {
          name: 'editReservation',
          props: true,
          meta: {
            title : 'Редактирование резерва',
            requiresAuth : true
          },
          path: 'reservations/:restaurantId/:reservationId',
          component: () => import('@/views/pages/Reservations/CreateReservation'),
        },
        // Tables
        {
          name: 'Гости',
          path: 'guests',
          component: () => import('@/views/pages/Guests/Index'),
        },
        {
          name: 'viewGuest',
          path: 'guests/:id/view',
          props: true,
          component: () => import('@/views/pages/Guests/View'),
        },
        {
          name: 'editGuest',
          path: 'guests/:id/edit',
          props: true,
          component: () => import('@/views/pages/Guests/Edit'),
        },
        // Maps
        {
          name: 'Google Maps',
          path: 'maps/google-maps',
          component: () => import('@/views/dashboard/maps/GoogleMaps'),
        },
      ],
    },
  ],
})




router.beforeEach((to, from, next) => {


  if (to.path === from.path && (to.hash !== from.hash)) {
    return;
  }

  if ((to.name === 'Login' || to.name === 'Register') && store.getters['auth/loggedIn']) {
    next({name: 'Dashboard'})
  }

  // auth
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if ((!store.getters['auth/loggedIn'])) {
      next({name: 'Login'})
      return
    }
  }

  next()
})


export default router;
